<template>
    <div
        class="m-5 md:m-15 2xl:m-20"
        @keydown="progressbar.userKeyDown()"
        @keyup="progressbar.userKeyUp()"
        @click="calculate_progress"
    >
        <h3 id="form-situation-pro" class="mb-15 2xl:mb-20 w-full">Situation Professionnelle</h3>

        <!-- BEGIN Situation professionnelle -->
        <div class="grid grid-cols-12 gap-x-4 gap-y-10">
            <input-text
                name="poste_actuel"
                class="md:col-span-6"
                libelle="Poste principal actuel"
                label-libelle="Fonction principale occupée par le salarié au sein de l'entreprise."
                :value="form.poste_actuel" @input="(newValue) => {form.poste_actuel = newValue}"
                :necessary="true"
            />

            <input-select
                name="situation_anterieure"
                :class="(form.situation_anterieure === 'Autre') ? 'md:col-span-3' : 'md:col-span-6'"
                libelle="Situation antérieure à l'entrée dans la structure"
                :value="form.situation_anterieure" @input="(newValue) => {form.situation_anterieure = newValue}"
                :datas="[
                    {value:'Demandeur d\'Emploi'},
                    {value:'Scolarité classique ou Formation'},
                    {value:'Institution ou Service Spécialisé (IME, SIPFP, IES, IEM...)'},
                    {value:'Service d\'Accompagnement Social (SSAD, SESSAD, SAVS...)'},
                    {value:'Etablissement et Service d\'Aide par le Travail (ESAT)'},
                    {value:'Entreprise Adaptée (EA)'},
                    {value:'Centre de Distribution de Travail à Domicile (CDTD)'},
                    {value:'Entreprise d\'Insertion (EI)'},
                    {value:'Entreprise de Travail Temporaire (ETT, ETTI)'},
                    {value:'Milieu Ordinaire / Handicap'},
                    {value:'Milieu Ordinaire / Inaptitude'},
                    {value:'Institution Sanitaire (CHR, CHS, CRF...) / Hospitalisation'},
                    {value:'Autre'},
                ]"
                :necessary="true"
            />

            <transition
                enter-active-class="ease-in duration-300"
                enter-class="opacity-0"
                leave-active-class="ease-out duration-300"
                leave-to-class="opacity-0"
            >
                <input-text
                    v-if="form.situation_anterieure === 'Autre'"
                    class="md:col-span-3"
                    name="situation_anterieure_precis"
                    libelle="Autre situation"
                    :value="form.situation_anterieure_precis"
                    @input="(newValue) => {form.situation_anterieure_precis = newValue}"
                    :necessary="true"
                />
            </transition>

            <input-text
                name="employeur_actuel"
                class="md:col-span-3"
                libelle="Nom de l'employeur actuel"
                :value="form.employeur_actuel" @input="(newValue) => {form.employeur_actuel = newValue}"
                :necessary="true"
            />

            <input-text
                name="site"
                class="md:col-span-3"
                libelle="Lieu de travail"
                label-libelle="Zone géographique où une personne exerce son activité professionnelle (INSEE). Par convention, les personnes exerçant des professions les amenant à se déplacer plus ou moins fréquemment sont considérées comme travaillant dans leur commune de résidence."
                :value="form.site" @input="(newValue) => {form.site = newValue}"
                :necessary="true"
            />

            <input-text
                name="service"
                class="md:col-span-3"
                libelle="Service / secteur"
                label-libelle="Regroupement d’un ensemble de métiers appartenant à la même spécialité (Sous-Traitance Industrielle, Espaces verts, Electricité, Electronique...)"
                :value="form.service" @input="(newValue) => {form.service = newValue}"
                :necessary="true"
            />

            <date-picker
                name="date_structure"
                :necessary-date="true"
                class="col-span-full md:col-span-3"
                libelle="Date d'entrée dans la structure"
                format="dd/MM/yyyy"
                initialview="year"
                :value="form.date_structure" @input="(newValue) => {form.date_structure = newValue}"
                :necessary="true"
            />

            <input-text
                name="responsable"
                class="md:col-span-3"
                libelle="Responsable hiérarchique"
                :value="form.responsable" @input="(newValue) => {form.responsable = newValue}"
                :necessary="true"
            />

            <input-text
                name="anciennete_poste"
                class="md:col-span-3"
                libelle="Ancienneté dans le poste"
                :value="form.anciennete_poste" @input="(newValue) => {form.anciennete_poste = newValue}"
                :necessary="true"
            />

            <input-select
                name="type_contrat"
                class="md:col-span-3"
                libelle="Type de contrat"
                :value="form.type_contrat" @input="(newValue) => {form.type_contrat = newValue}"
                :datas="[
                {value:'Contrat de soutien et d\'aide par le travail'},
                {value:'Contrat de travail à durée indéterminée'},
                {value:'Contrat de travail à durée déterminée'},
                {value:'Contrat d\'apprentissage'},
                {value:'Contrat de prestation de service'},
                {value:'Contrat de professionnalisation'},
                {value:'Contrat de travail intérimaire'},
                {value:'Contrat unique d\'insertion - Secteur privé'},
                {value:'Contrat unique d\'insertion - Secteur public'},
                {value:'Autres contrats'},
                ]"
                :necessary="true"
            />

            <transition
                enter-active-class="ease-in duration-300"
                enter-class="opacity-0"
                leave-active-class="ease-out duration-300"
                leave-to-class="opacity-0"
            >
                <input-text
                    v-if="form.type_contrat === 'Autres contrats'"
                    class="md:col-span-3"
                    name="type_contrat_precis"
                    libelle="Autre type de contrat"
                    :value="form.type_contrat_precis"
                    @input="(newValue) => {form.type_contrat_precis = newValue}"
                    :necessary="true"
                />
            </transition>

            <input-select
                name="temps_travail"
                class="md:col-span-3"
                libelle="Temps de travail"
                :value="form.temps_travail" @input="(newValue) => {form.temps_travail = newValue}"
                :datas="[
                    {value:'Temps plein'},
                    {value:'Temps partiel'},
                ]"
                :necessary="true"
            />


            <input-text
                name="horaires"
                class="md:col-span-3"
                libelle="Horaires"
                :value="form.horaires" @input="(newValue) => {form.horaires = newValue}"
                :necessary="true"
            />

            <input-select
                name="qualification"
                class="md:col-span-3"
                libelle="Qualification"
                label-libelle="Appréciation, sur une grille hiérarchique, de la valeur professionnelle d'un salarié, en fonction de sa formation initiale, de son expérience professionnelle, de la nature de son travail et de son niveau de responsabilité."
                :value="form.qualification" @input="(newValue) => {form.qualification = newValue}"
                :datas="[
                    {value: 'Non précisé'},
                    {value: 'Manoeuvres'},
                    {value: 'Ouvriers non qualifiés'},
                    {value: 'Ouvriers qualifiés'},
                    {value: 'Employés non qualifiés'},
                    {value: 'Employés qualifiés'},
                    {value: 'Techniciens'},
                    {value: 'Ingénieurs et cadres'},
                    {value: 'Autres'},
                ]"
                :necessary="true"
            />

            <transition
                enter-active-class="ease-in duration-300"
                enter-class="opacity-0"
                leave-active-class="ease-out duration-300"
                leave-to-class="opacity-0"
            >
                <input-text
                    v-if="form.qualification === 'Autres'"
                    class="md:col-span-3"
                    name="qualification_precis"
                    libelle="Autre qualification"
                    :value="form.qualification_precis"
                    @input="(newValue) => {form.qualification_precis = newValue}"
                    :necessary="true"
                />
            </transition>

            <input-select
                name="statut2"
                class="md:col-span-3"
                libelle="Statut"
                label-libelle="Notion qui permet de distinguer les actifs ayant un emploi suivant un ensemble de droits et de devoirs acquis ou prescris. Elle permet de repérer où l'individu se situe dans le système social."
                :value="form.statut2" @input="(newValue) => {form.statut2 = newValue}"
                :datas="[
                    {value: 'Usager'},
                    {value: 'Salarié handicapé bénéficiant de l\'aide au poste'},
                    {value: 'Salarié valide'},
                    {value: 'Salarié handicapé ne bénéficiant pas de l\'aide au poste'},
                    {value: 'Intérimaire'},
                    {value: 'Stagiaire'},
                    {value: 'Compagne / Compagnon'},
                    {value: 'Autre'},
                ]"
                :necessary="true"
            />

            <transition
                enter-active-class="ease-in duration-300"
                enter-class="opacity-0"
                leave-active-class="ease-out duration-300"
                leave-to-class="opacity-0"
            >
                <input-text
                    v-if="form.statut2 === 'Autre'"
                    class="md:col-span-3"
                    name="statut2_precis"
                    libelle="Autre statut"
                    :value="form.statut2_precis"
                    @input="(newValue) => {form.statut2_precis = newValue}"
                    :necessary="true"
                />
            </transition>

            <input-text
                name="remuneration"
                class="md:col-span-3"
                libelle="Rémunération (mens. brute €)"
                replace-tooltip-libelle="Rémunération (mensuelle brute €)"
                :value="form.remuneration" @input="(newValue) => {form.remuneration = newValue}"
                :necessary="true"
            />

            <input-text
                name="dif"
                class="md:col-span-3"
                libelle="Crédit CPF"
                label-libelle="Notion qui permet de distinguer les actifs ayant un emploi suivant un ensemble de droits et de devoirs acquis ou prescris. Elle permet de repérer où l'individu se situe dans le système social."
                :value="form.dif" @input="(newValue) => {form.dif = newValue}"
                :necessary="true"
            />
        </div>

        <hr v-if="$can('situationprofessionnelle_edit') || form.habilitation_pro.length > 0" class="border-dashed border-gray-600 my-10"/>

        <!-- BEGIN List of Habilitations -->
        <div
v-for="(habilitation, index) in form.habilitation_pro"
            :key="index"
            class="transition-all duration-300 flex mb-10 space-x-4"
            :class="{'pb-10 border-b border-gray-600' : index < form.habilitation_pro.length-1}"
        >
            <delete-button @del="deleteItem(form.habilitation_pro, index)" class="pt-6" />
            <div class="grid grid-cols-12 gap-x-4 gap-y-10 w-full">
                <input-select
                    :name="'habilitation_type'+index"
                    :necessary="true"
                    :class="(habilitation.habilitation_type == 'Autres') ? 'md:col-span-2' : 'md:col-span-4'"
                    libelle="Habilitations électriques"
                    label-libelle="L'habilitation électrique est une exigence réglementaire pour tous les travailleurs qui effectuent des opérations sur les installations électriques ou dans leur voisinage. Elle nécessite une formation préalable.#Le titre d’habilitation est ensuite délivré par l’employeur. Il forme la reconnaissance, par un employeur de la capacité d’une personne à accomplir en sécurité les tâches fixées. L’habilitation n’est pas un document lié à la position hiérarchique ni à la classification professionnelle. L’habilitation est matérialisée par un document établi par l’employeur et signé par l’employeur et par l’habilité. La délivrance d’une habilitation par l’employeur ne dégage pas pour autant la responsabilité de ce dernier. L’habilitation n’autorise pas, à elle seule, un titulaire à effectuer de son propre chef des opérations pour lesquelles il est habilité. Il doit en outre être désigné par son employeur pour l’exécution de ces opérations. L’affectation à un poste de travail peut constituer une désignation implicite."
                    :value="habilitation.habilitation_type" @input="(newValue) => {habilitation.habilitation_type = newValue}"
                    :datas="[
                        {group: 'Type B', value: 'B0'},
                        {group: 'Type B', value: 'B1'},
                        {group: 'Type B', value: 'B2'},
                        {group: 'Type B', value: 'BC'},
                        {group: 'Type B', value: 'BR'},
                        {group: 'Type B', value: 'BS'},
                        {group: 'Type B', value: 'BP'},
                        {group: 'Type B', value: 'BE'},
                        {group: 'Type H', value: 'H0'},
                        {group: 'Type H', value: 'H1'},
                        {group: 'Type H', value: 'H2'},
                        {group: 'Type H', value: 'HC'},
                        {group: 'Type H', value: 'HR'},
                        {group: 'Type H', value: 'HS'},
                        {group: 'Type H', value: 'HP'},
                        {group: 'Type H', value: 'HE'},
                        {group: ' ', value: 'Autres'},
                    ]"
                />

                <transition
                    enter-active-class="ease-in duration-300"
                    enter-class="opacity-0"
                    leave-active-class="ease-out duration-300"
                    leave-to-class="opacity-0"
                >
                    <input-text
                        v-if="habilitation.habilitation_type == 'Autres'"
                        :necessary="true"
                        class="md:col-span-2"
                        :name="'habilitation_type_precis'+index"
                        libelle="Autre habilitation"
                        :value="habilitation.habilitation_type_precis"
                        @input="(newValue) => {habilitation.habilitation_type_precis = newValue}"
                    />
                </transition>

                <input-text
                    :name="'habilitation_autorite'+index"
                    :necessary="true"
                    class="md:col-span-4"
                    libelle="Autorité délivrante"
                    :value="habilitation.habilitation_autorite"
                    @input="(newValue) => {habilitation.habilitation_autorite = newValue}"
                />

                <date-picker
                    format="dd/MM/yyyy"
                    :necessary-date="true"
                    initialview="year"
                    :name="'habilitation_date'+index"
                    class="col-span-full md:col-span-4"
                    libelle="Date de fin de validité"
                    :value="habilitation.habilitation_date"
                    @input="(newValue) => {habilitation.habilitation_date = newValue}"
                />
            </div>
        </div>
        <!-- END List of Habilitations -->

    <!-- BEGIN Button to add a "habilitation_pro"  -->
    <add-button
        id="form-habilitation"
        libelle="Ajouter une habilitation"
        @add="addItem(form.habilitation_pro, habilitation_pro)"
    />
    <!-- END Button to add a "habilitation_pro" -->

        <hr v-if="$can('situationprofessionnelle_edit') || form.autorisation_exercice.length > 0" class="border-dashed border-gray-600 my-10"/>

        <!-- BEGIN List of Autorisations -->
        <div
v-for="(autorisation, index) in form.autorisation_exercice"
            :key="index"
            class="transition-all duration-300 flex mb-10 space-x-4"
            :class="{'pb-10 border-b border-gray-600' : index < form.autorisation_exercice.length-1}"
        >
            <delete-button @del="deleteItem(form.autorisation_exercice, index)" class="pt-6" />
            <div class="grid grid-cols-12 gap-x-4 gap-y-10 w-full">
                <input-select
                    :name="'autorisation_type'+index"
                    :necessary="true"
                    :class="(autorisation.autorisation_type == 'Autres') ? 'md:col-span-2' : 'md:col-span-4'"
                    libelle="Certificats d'Autorisation d'Exercice"
                    label-libelle="<div class='block'><b>Le Certificat d’Aptitude à la Conduite en Sécurité</b>, abrégé en CACES, permet de valider, pour l'essentiel, la conduite d'engins de manutention. Celui-ci n'est pas un certificat de compétences professionnelles (au sens métier du terme), c'est une validation obtenue au travers d'un test théorique et pratique des connaissances de l'opérateur pour la conduite en sécurité du matériel concerné.<br /><br />
                                    <div class='block'><b>Le Service de Sécurité Incendie et d’Assistance à Personnes</b>, abrégé en SSIAP regroupe un ensemble de connaissances nécessaires pour assurer la sécurité des personnes et la sécurité incendie des biens au sein des Établissements Recevant du Public (ERP) et des Immeubles de Grandes Hauteurs (IGH). Il permet d’assurer la fonction d’Agent de Sécurité Incendie. Trois catégories de personnels sont présents dans un service de sécurité incendie et d'assistance aux personnes:
                                    <div>
                                    <ul class='list-disc list-inside'>
                                    <li>L'agent de service de sécurité incendie et d'assistance aux personnes (il est titulaire du diplôme SSIAP1)</li>
                                    <li>Le chef d'équipe sécurité incendie et d'assistance aux personnes (titulaire du SSIAP2)</li>
                                    <li>Le chef de service de sécurité incendie et d'assistance aux personnes (titulaire du SSIAP3).</li></ul>"
                    :value="autorisation.autorisation_type" @input="(newValue) => {autorisation.autorisation_type = newValue}"
                    :datas="[
                        {value: 'CACES1'},
                        {value: 'CACES2'},
                        {value: 'CACES3'},
                        {value: 'CACES4'},
                        {value: 'CACES5'},
                        {value: 'CACES6'},
                        {value: 'CACES7'},
                        {value: 'CACES8'},
                        {value: 'CACES9'},
                        {value: 'CACES10'},
                        {value: 'Autres'},
                    ]"
                />

                <transition
                    enter-active-class="ease-in duration-300"
                    enter-class="opacity-0"
                    leave-active-class="ease-out duration-300"
                    leave-to-class="opacity-0"
                >
                    <input-text
                        v-if="autorisation.autorisation_type == 'Autres'"
                        :necessary="true"
                        class="md:col-span-2"
                        :name="'autorisation_type_precis'+index"
                        libelle="Autre type de certificat"
                        :value="autorisation.autorisation_type_precis"
                        @input="(newValue) => {autorisation.autorisation_type_precis = newValue}"
                    />
                </transition>

                <input-text
                    :name="'autorisation_autorite'+index"
                    :necessary="true"
                    class="md:col-span-4"
                    libelle="Autorité délivrante"
                    :value="autorisation.autorisation_autorite" @input="(newValue) => {autorisation.autorisation_autorite = newValue}"
                />

                <date-picker
                    :name="'autorisation_date'+index"
                    :necessary-date="true"
                    format="dd/MM/yyyy"
                    initialview="year"
                    class="col-span-full md:col-span-4"
                    libelle="Date de fin de validité"
                    :value="autorisation.autorisation_date" @input="(newValue) => {autorisation.autorisation_date = newValue}"
                />
            </div>
        </div>
        <!-- END List of Autorisations -->

        <!-- BEGIN Button to add a "autorisation_exercice" -->
        <add-button
            id="form-certif" libelle="Ajouter un certificat d'autorisation d'exercice" @add="addItem(form.autorisation_exercice, autorisation_exercice)" />
        <!-- END Button to add a "autorisation_exercice" -->

        <hr v-if="$can('situationprofessionnelle_edit') || form.connaissances_securite_incendie.length > 0" class="border-dashed border-gray-600 my-10"/>

        <!-- BEGIN List of securite_incendie -->
        <div
v-for="(connaissance, index) in form.connaissances_securite_incendie"
            :key="index"
            class="transition-all duration-300 flex mb-10 space-x-4"
            :class="{'pb-10 border-b border-gray-600' : index < form.connaissances_securite_incendie.length-1}"
        >
            <delete-button @del="deleteItem(form.connaissances_securite_incendie, index)" class="pt-6" />
            <div class="grid grid-cols-12 gap-x-4 gap-y-10 w-full">
                <input-select
                    :name="'securite_incendie'+index"
                    :necessary="true"
                    :class="(connaissance.securite_incendie == 'Autres') ? 'md:col-span-2' : 'md:col-span-4'"
                    libelle="Secours - Sécurité Incendie"
                    :value="connaissance.securite_incendie" @input="(newValue) => {connaissance.securite_incendie = newValue}"
                    :datas="[
                        {value: 'PSC1'},
                        {value: 'PSE1'},
                        {value: 'SST'},
                        {value: 'SSIAP1'},
                        {value: 'SSIAP2'},
                        {value: 'SSIAP3'},
                        {value: 'Autres'},
                    ]"
                />

                <transition
                    enter-active-class="ease-in duration-300"
                    enter-class="opacity-0"
                    leave-active-class="ease-out duration-300"
                    leave-to-class="opacity-0"
                >
                    <input-text
                        v-if="connaissance.securite_incendie == 'Autres'"
                        :necessary="true"
                        class="md:col-span-2"
                        :name="'securite_incendie_precis'+index"
                        libelle="Autre"
                        :value="connaissance.securite_incendie_precis"
                        @input="(newValue) => {connaissance.securite_incendie_precis = newValue}"
                    />
                </transition>

                <input-text
                    :name="'secours_autorite'+index"
                    :necessary="true"
                    class="md:col-span-4"
                    libelle="Autorité délivrante"
                    :value="connaissance.secours_autorite" @input="(newValue) => {connaissance.secours_autorite = newValue}"
                />

                <date-picker
                    :name="'secours_date'+index"
                    :necessary-date="true"
                    format="dd/MM/yyyy"
                    initialview="year"
                    class="col-span-full md:col-span-4"
                    libelle="Date de fin de validité"
                    :value="connaissance.secours_date" @input="(newValue) => {connaissance.secours_date = newValue}"
                />
            </div>
        </div>
        <!-- END List of securite_incendie -->

        <!-- BEGIN Button to add a "securite_incendie" -->
        <add-button
            id="form-diplome" libelle='Ajouter un diplôme en "Secours - Sécurité Incendie"' @add="addItem(form.connaissances_securite_incendie, connaissances_securite_incendie)" />
        <!-- END Button to add a "securite_incendie" -->

        <hr class="border-dashed border-gray-600 my-10"/>

        <div class="grid grid-cols-12 gap-x-4 gap-y-10">
            <checkbox-indigo
                name="aptitude_medicale"
                class="col-span-full md:col-span-6 place-self-start"
                libelle="Aptitude médicale au poste de travail"
                label-libelle="Délivré par le médecin du travail, il donne un avis sur l'aptitude médicale du salarié à son poste de travail après l'une des visites médicales prévue par les articles R.4624-10 et suivants du Code du travail. Il pourra s'agir soit d'une visite médicale d'embauche, soit d'une visite médicale périodique, soit enfin d'une visite médicale de reprise."
                :value="form.aptitude_medicale" @input="(newValue) => {form.aptitude_medicale = newValue}"
                :is-checkbox-right="true"
            />
            <date-picker
                v-if="form.aptitude_medicale"
                :necessary-date="true"
                format="dd/MM/yyyy"
                initialview="year"
                name="aptitude_validite"
                class="col-span-full md:col-span-6"
                libelle="Fin de validité de la visite médicale"
                :value="form.aptitude_validite" @input="(newValue) => {form.aptitude_validite = newValue}"
            />

            <transition
                enter-active-class="duration-300"
                enter-class="opacity-0"
                enter-to-class="opacity-100"
            >
                <div
v-if="form.aptitude_medicale"
                    class="col-span-full grid grid-cols-12 gap-x-4 gap-y-10"
                >
                    <input-select
                        name="aptitude_partielle"
                        :necessary="true"
                        class="md:col-span-4"
                        libelle="Avis d'inaptitude au poste de travail 1/2"
                        label-libelle="Elle est prononcée, après un examen médical et une étude de poste, par le médecin du travail dont la mission est de vérifier la compatibilité de la santé du salarié avec le travail à effectuer et de proposer les aménagements nécessaires. À ne pas confondre avec l’arrêt de travail délivré par un médecin ou encore avec l’invalidité, décidée par le médecin conseil de la caisse primaire d’assurance maladie (CPAM)."
                        :value="form.aptitude_partielle" @input="(newValue) => {form.aptitude_partielle = newValue}"
                        :datas="[
                        {value: 'Partielle'},
                        {value: 'Totale'},
                        ]"
                    />

                    <input-select
                        name="aptitude_temporaire"
                        :necessary="true"
                        class="md:col-span-4"
                        libelle="Avis d'inaptitude au poste de travail 2/2"
                        :value="form.aptitude_temporaire" @input="(newValue) => {form.aptitude_temporaire = newValue}"
                        :datas="[
                        {value: 'Temporaire'},
                        {value: 'Définitive'},
                        ]"
                    />

                    <input-text
                        name="aptitude_delivre"
                        :necessary="true"
                        class="md:col-span-4"
                        libelle="Délivré par"
                        :value="form.aptitude_delivre" @input="(newValue) => {form.aptitude_delivre = newValue}"
                    />

                    <input-select
                        name="invalidite"
                        :necessary="true"
                        class="md:col-span-4"
                        libelle="Invalidité"
                        label-libelle="L’invalidité est décidée par le médecin conseil de la CPAM. C’est une réduction de la capacité de travail du salarié, elle dépend du code de la sécurité sociale."
                        :value="form.invalidite" @input="(newValue) => {form.invalidite = newValue}"
                        :datas="[
                        {value: 'Oui'},
                        {value: 'Non'},
                        ]"
                    />

                    <transition
                        enter-active-class="duration-300"
                        enter-class="opacity-0"
                        enter-to-class="opacity-100"
                    >
                        <div
v-if="form.invalidite == 'Oui'"
                            class="col-span-full md:col-span-8 grid grid-cols-8 gap-x-4 gap-y-10"
                        >
                        <input-select
                            name="categorie_invalidite"
                            :necessary="true"
                            class="md:col-span-4"
                            libelle="Avis d'inaptitude au poste de travail 1/2"
                            :value="form.categorie_invalidite" @input="(newValue) => {form.categorie_invalidite = newValue}"
                            :datas="[
                            {value: '1ère catégorie'},
                            {value: '2ème catégorie'},
                            {value: '3ème catégorie'},
                            ]"
                        />
                        <input-text
                            name="invalidite_delivre"
                            :necessary="true"
                            class="md:col-span-4"
                            libelle="Délivré par"
                            :value="form.invalidite_delivre" @input="(newValue) => {form.invalidite_delivre = newValue}"
                        />
                        </div>
                    </transition>
                </div>
            </transition>

            <input-text-area
                name="recommandations2"
                class="col-span-full"
                libelle="Recommandations et propositions de mesures individuelles"
                :size="5" :value="form.recommandations2" @input="(newValue) => {form.recommandations2 = newValue}"
            />
        </div>
        <!-- END Situation professionnelle -->
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import InputSelect from '../../../components/Inputs/InputSelect';
import MultipleSelect from '../../../components/Inputs/MultipleSelect';
import DatePicker from '../../../components/Inputs/DatePicker';
import CheckboxGreen from '../../../components/Inputs/CheckboxGreen';
import CheckboxForm from '../../../components/Inputs/CheckboxForm';
import Icon from '../../../components/Icon';
import CheckboxIndigo from '../../../components/Inputs/CheckboxIndigo';
import AddButton from '../../../components/Inputs/AddButton';
import DeleteButton from '../../../components/Inputs/DeleteButton';

export default {
  components: {
    InputText,
    InputTextArea,
    InputSelect,
    MultipleSelect,
    DatePicker,
    CheckboxGreen,
    CheckboxForm,
    Icon,
    CheckboxIndigo,
    AddButton,
    DeleteButton,
  },

  props:['progressbar'],

  name: 'Situationprofessionnelle',

  data() {
    return {
      // Initial state of the form
      form: {
        poste_actuel: '',
        situation_anterieure: '',
        situation_anterieure_precis: '',
        employeur_actuel: '',
        site: '',
        service: '',
        date_structure: '',
        responsable: '',
        anciennete_poste: '',
        type_contrat: '',
        type_contrat_precis: '',
        temps_travail: '',
        horaires: '',
        qualification: '',
        qualification_precis: '',
        statut2: '',
        statut2_precis: '',
        remuneration: '',
        dif: '',
        habilitation_pro: [],
        autorisation_exercice: [],
        connaissances_securite_incendie: [],
        aptitude_validite: '',
        aptitude_medicale: false,
        aptitude_partielle: '',
        aptitude_temporaire: '',
        aptitude_delivre: '',
        invalidite: '',
        categorie_invalidite: '',
        invalidite_delivre: '',
        recommandations2: '',
      },

      habilitation_pro:{
        habilitation_type:'',
        habilitation_type_precis:'',
        habilitation_autorite:'',
        habilitation_date:'',
      },

      autorisation_exercice:{
        autorisation_type:'',
        autorisation_type_precis:'',
        autorisation_autorite:'',
        autorisation_date:'',
      },

      connaissances_securite_incendie:{
        securite_incendie:'',
        securite_incendie_precis:'',
        secours_autorite:'',
        secours_date:'',
      },
    };
  },
  async mounted() {
    await this.initForm(); // asynchrone function to wait do actions, then re-pass isFormChanged to false (actions in form pass this var to true)

    this.calculate_progress();
    this.infosPage.isFormChanged = false; // here, change value of isFormChanged to false to indicate that there is not change in form
  },
  methods: {
    ...mapMutations({
      SET_INFOSPAGES: 'neopass/SET_INFOSPAGE',
      calculate_progress: 'neopass/calculate_progress',
    }),

    initForm() {
      //load values in form and keep formContent with initial values to compare when leave page without saving
      Object.assign(this.form, this.formContent);
    },

    addItem(el, item={}) {
      el.push({...item});
    },

    deleteItem(el, index) {
      el.splice(index, 1);
    },
  },
  computed: {
    ...mapGetters({
      formContent: 'neopass/formContent',
      infosPage: 'neopass/infosPage',
    }),
  },
  watch: {
    form: {
      handler() {
        //assign true to flag to know if there is a change in form
        this.infosPage.isFormChanged = true;
      },
      deep: true,
    },
  },
};
</script>
